import svgUrl from "ni:svgr;9jS2vHZI91BSohzfj6JdFwY6EJLlZxep9u5zMkkl8TE";
export default svgUrl;
import * as React from "react";
import { memo } from "react";
const UiEnrichmentFirecrawlSIcon = props => <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><g filter="var(--tbl--ui-node-icon--enrichment--firecrawl-s)"><text fill="currentColor" textAnchor="middle" x="50%" y="50%" dy=".5em" fontSize="16px">{"\uD83D\uDD25"}</text></g><defs><filter id="tbl--ui-node-icon--enrichment--firecrawl-s--disabled"><feColorMatrix type="saturate" values={0.01} /></filter></defs></svg>;
const Memo = memo(UiEnrichmentFirecrawlSIcon);
export { Memo as ReactComponent };
if (import.meta.env.DEV) {
  Memo.displayName = "ui-node-icon(UiEnrichmentFirecrawlSIcon)";
}